import React, { useState, useEffect } from 'react'
import './goals_tabs.css'
import { Link, useNavigate } from 'react-router-dom'
import { getGoals } from 'src/services/APIs/Goals/getGoals'
import { CSidebar, CSpinner, CTabContent } from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilX } from '@coreui/icons'
import GoalCarousel from './goalsComponents/goalCarousel'
import { GoalsCarouselContainer, GoalsContainer } from './styledComponents'
import { useContext } from 'react'
import { ThemeContext } from 'src/context/ThemeContext'
import {
  AddOrganizationalGoalsButton,
  OrganizationalGoalsHeading,
} from './goalsComponents/styledComponents'
import Add from '@mui/icons-material/Add'
import TaskAlt from '@mui/icons-material/TaskAlt'

const randomProgressData = {
  'company-wide': [
    { progress: 89, sessions: 27, minutes: 557 },
    { progress: 93, sessions: 21, minutes: 468 },
    { progress: 52, sessions: 60, minutes: 329 },
    { progress: 95, sessions: 32, minutes: 570 },
    { progress: 78, sessions: 61, minutes: 399 },
    { progress: 79, sessions: 67, minutes: 668 },
    { progress: 92, sessions: 18, minutes: 446 },
    { progress: 60, sessions: 23, minutes: 176 },
    { progress: 53, sessions: 29, minutes: 132 },
    { progress: 88, sessions: 27, minutes: 140 },
  ],
  support: [
    { progress: 76, sessions: 15, minutes: 200 },
    { progress: 15, sessions: 9, minutes: 100 },
    { progress: 61, sessions: 1, minutes: 10 },
    { progress: 59, sessions: 20, minutes: 300 },
    { progress: 12, sessions: 16, minutes: 130 },
    { progress: 82, sessions: 5, minutes: 50 },
    { progress: 24, sessions: 7, minutes: 67 },
    { progress: 24, sessions: 8, minutes: 40 },
    { progress: 83, sessions: 3, minutes: 30 },
    { progress: 15, sessions: 9, minutes: 60 },
  ],
  engineering: [
    { progress: 23, sessions: 2, minutes: 34 },
    { progress: 89, sessions: 3, minutes: 45 },
    { progress: 34, sessions: 23, minutes: 45 },
    { progress: 12, sessions: 6, minutes: 45 },
    { progress: 45, sessions: 5, minutes: 56 },
    { progress: 23, sessions: 34, minutes: 245 },
    { progress: 56, sessions: 4, minutes: 300 },
    { progress: 34, sessions: 6, minutes: 23 },
    { progress: 12, sessions: 6, minutes: 23 },
    { progress: 78, sessions: 5, minutes: 23 },
  ],
  operations: [
    { progress: 56, sessions: 4, minutes: 300 },
    { progress: 78, sessions: 5, minutes: 23 },
    { progress: 23, sessions: 34, minutes: 245 },
    { progress: 12, sessions: 6, minutes: 45 },
    { progress: 34, sessions: 6, minutes: 23 },
    { progress: 34, sessions: 23, minutes: 45 },
    { progress: 89, sessions: 3, minutes: 45 },
    { progress: 45, sessions: 5, minutes: 56 },
    { progress: 12, sessions: 6, minutes: 23 },
    { progress: 23, sessions: 2, minutes: 34 },
  ],
  production: [
    { progress: 34, sessions: 6, minutes: 23 },
    { progress: 56, sessions: 4, minutes: 300 },
    { progress: 34, sessions: 23, minutes: 45 },
    { progress: 12, sessions: 6, minutes: 45 },
    { progress: 23, sessions: 34, minutes: 245 },
    { progress: 78, sessions: 5, minutes: 23 },
    { progress: 23, sessions: 2, minutes: 34 },
    { progress: 89, sessions: 3, minutes: 45 },
    { progress: 45, sessions: 5, minutes: 56 },
    { progress: 12, sessions: 6, minutes: 23 },
  ],
}

const Goals = ({ title, description, bg }) => {
  const navigate = useNavigate()
  const { theme } = useContext(ThemeContext)
  const [items, setItems] = useState([{}])
  const [renderItems, setRenderItems] = useState(true)
  const [loading, setLoading] = useState(false)
  const [visible, setVisible] = useState(false)
  const [desc, setDesc] = useState([])
  const [windowWidth, setWindowWidth] = useState(0)
  const [sliderSettings, setSliderSettings] = useState({
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
  })

  const [selectedId, setSelectedId] = useState('company-wide')

  const customer_goals = async () => {
    setLoading(true)
    const response = await getGoals()
    console.log(response.data)
    response.data.length !== 0 ? setItems(response.data) : setRenderItems(false)
    setLoading(false)
    if (response.status !== 200) {
      console.log('error')
    }
  }

  const RenderCarousel = ({ selectedId }) => {
    return renderItems === true ? (
      <GoalCarousel
        items={items?.map((goal, goalIndex) => {
          return {
            ...goal,
            ...randomProgressData?.[selectedId]?.[
              goalIndex % Object.keys(randomProgressData)?.length
            ],
          }
        })}
        setDesc={setDesc}
        setVisible={setVisible}
        visible={visible}
      />
    ) : (
      <div className="w-full px-3">
        <Link to={'organization-goals'}>
          <button
            className="btn btn-outline-secondary flex align-items-center justify-content-center h-44 w-full"
            style={{
              borderRadius: '1rem',
            }}
          >
            <h3 className="">Add goals for your company to get started.</h3>
          </button>
        </Link>
      </div>
    )
  }

  function handleAddGoal() {
    navigate('organization-goals')
  }
  const updateWindowWidth = () => {
    setWindowWidth(window.innerWidth)
  }

  useEffect(() => {
    window.addEventListener('resize', updateWindowWidth)

    // Clean up the event listener on component unmount
    return () => window.removeEventListener('resize', updateWindowWidth)
  }, [])

  useEffect(() => {
    customer_goals()
  }, [])

  return (
    <GoalsContainer themeType={theme}>
      <CSidebar
        style={{ background: '#625B7A' }}
        size="lg"
        overlaid
        placement="end"
        visible={visible}
      >
        <CTabContent>
          <button
            onClick={() => setVisible(!visible)}
            className="btn btn-ghost-danger mt-3 ml-2 rounded-pill"
            style={{ display: 'flex', alignItems: 'center' }}
          >
            <CIcon icon={cilX} size="xl" />
          </button>
          <div className="w-72 h-48 mx-auto mt-10 shadow-2xl rounded-2xl">
            <div
              className={`w-72 h-48 bg-[url(https://media.aumhum.com/images/prod/${desc.coverIcon})] bg-cover rounded-2xl mx-auto`}
            >
              <div
                className="absolute w-72 h-48 rounded-2xl"
                style={{
                  background: 'rgba(0, 0, 0, 0.5)',
                }}
              ></div>
              <h5 className="relative p-4 font-black text-white">{desc.name}</h5>
            </div>
          </div>
          <p className="p-4 text-center text-lg">{desc.longDesc}</p>
        </CTabContent>
      </CSidebar>
      <div className="d-flex flex-row align-items-center justify-content-between">
        <div className="flex flex-row items-center gap-3">
          <TaskAlt sx={{ color: 'rgba(255,255,255,0.95)', fontSize: '36px' }} />
          <OrganizationalGoalsHeading className="text-white">
            Wellness Goals
          </OrganizationalGoalsHeading>
        </div>
        {renderItems === true && (
          <AddOrganizationalGoalsButton onClick={handleAddGoal}>
            <Add sx={{ fontSize: '25px' }} /> {windowWidth > 768 ? <span>Add Goals</span> : <></>}
          </AddOrganizationalGoalsButton>
        )}
      </div>
      <div
        className="w-100 d-flex justify-content-start align-items-center gap-2 mt-3 mb-1 overflow-auto"
        style={{
          flexWrap: 'nowrap',
          paddingBottom: '4px',
          marginLeft: '-4px',
          marginRight: '-4px',
          WebkitOverflowScrolling: 'touch',
        }}
      >
        {tabsInWellnessGoals?.map((item, index) => (
          <WhiteButton
            key={index}
            text={item?.text}
            clickFunc={() => setSelectedId(item?.id)}
            selected={selectedId === item?.id}
          />
        ))}
      </div>
      <GoalsCarouselContainer>
        {loading ? <CSpinner /> : <RenderCarousel selectedId={selectedId} />}
      </GoalsCarouselContainer>
    </GoalsContainer>
  )
}
export default Goals

const WhiteButton = ({ clickFunc, text, selected }) => {
  return (
    <button
      type="button"
      onClick={clickFunc}
      style={{
        background: selected ? 'rgba(255, 255, 255, 0.35)' : 'rgba(255, 255, 255, 0.18)',
        color: 'white',
        borderRadius: '10px',
        padding: '10px 16px',
        minHeight: '44px',
        cursor: 'pointer',
        border: selected ? '1px solid rgba(255,255,255,0.5)' : '1px solid rgba(255,255,255,0.2)',
        fontWeight: selected ? 600 : 500,
        fontSize: '14px',
        fontFamily: 'Outfit, sans-serif',
        transition: 'all 0.2s ease',
        flexShrink: 0,
      }}
      onMouseEnter={(e) => {
        if (!selected) {
          e.currentTarget.style.background = 'rgba(255, 255, 255, 0.25)'
          e.currentTarget.style.borderColor = 'rgba(255,255,255,0.35)'
        }
      }}
      onMouseLeave={(e) => {
        if (!selected) {
          e.currentTarget.style.background = 'rgba(255, 255, 255, 0.18)'
          e.currentTarget.style.borderColor = 'rgba(255,255,255,0.2)'
        }
      }}
    >
      {text}
    </button>
  )
}

const tabsInWellnessGoals = [
  {
    text: 'Company-wide',
    id: 'company-wide',
  },
  {
    text: 'Support Team',
    id: 'support',
  },
  {
    text: 'Engineering',
    id: 'engineering',
  },
  {
    text: 'Operations',
    id: 'operations',
  },
  {
    text: 'Production',
    id: 'production',
  },
]
